import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import PresentAdder from './PresentAdder';
import PresentGetter from './PresentGetter';
import Present from './Present';
import Profile from './Profile';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
const root = ReactDOM.createRoot(document.getElementById('root'));
const presentAddress = "0x2fB0064CF81C81e61dE23C29B403e77824Fd6537";

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/add" element={<PresentAdder address = {presentAddress}/>} />
      <Route path ="/" element= {<PresentGetter address = {presentAddress}/>} />
      <Route path ="/:id" element= {<Present address = {presentAddress}/>} />
      <Route path ="/profile" element= {<Profile address = {presentAddress}/>} />

    </Routes>
  </BrowserRouter>
);

